export const TIME_SPEED = 200
export const TIME_SPEED_SLOW = 500
export const TIME_SPEED_NORMAL = 200
export const TIME_SPEED_MEDIUM = 100
export const TIME_SPEED_FAST = 50
export const TIME_SPEED_SUPER_FAST = 20

// This is the main color of the array bars.
export const PRIMARY_COLOR = 'turquoise'

// This is the color of array bars that are being compared throughout the animations.
export const SECONDARY_COLOR = 'Crimson'
// Color after sorted
export const THIRST_COLOR = 'rgb(0, 250, 154)' /* MediumSpringGreen */

export const CORLOR_RUN = 'DarkSlateBlue'

export const YELLOW_COLOR = 'yellow'
export const ORANGE_COLOR = 'orange'
export const PINK_COLOR = 'pink'

export const QUICK_SORT = 'Quick Sort'
export const HEAP_SORT = 'Heap Sort'
export const SELECT_SORT = 'Select Sort'
export const BUBBLE_SORT = 'Bubble Sort'
export const MERGED_SORT = 'Merged Sort'
export const INSERT_SORT = 'Insert Sort'
export const SHELL_SORT = 'Shell Sort'
export const LIST_ALGORITHM = [
    {
        id: 1,
        type: QUICK_SORT,
    },
    {
        id: 2,
        type: MERGED_SORT,
    },
    {
        id: 3,
        type: SELECT_SORT,
    },
    {
        id: 4,
        type: BUBBLE_SORT,
    },
    {
        id: 5,
        type: HEAP_SORT,
    },
    {
        id: 6,
        type: INSERT_SORT,
    },
    {
        id: 7,
        type: SHELL_SORT,
    },
]
export const SPEED_SLOW = 'Slow'
export const SPEED_NORMAL = 'Normal'
export const SPEED_MEDIUM = 'Medium'
export const SPEED_FAST = 'Fast'
export const SPEED_SUPER_FAST = 'Super fast'
export const SPEEDS = [
    {
        id: 1,
        type: SPEED_SLOW,
    },
    {
        id: 2,
        type: SPEED_NORMAL,
    },
    {
        id: 3,
        type: SPEED_MEDIUM,
    },
    {
        id: 4,
        type: SPEED_FAST,
    },
    {
        id: 5,
        type: SPEED_SUPER_FAST,
    },
]
